import React, { useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';
import Slider from "react-slick";
import { connect } from "react-redux";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { doFetchProducts, getTrendingProduct } from "../../../actions/productAction";

import { CarouselProduct } from ".";

const TrendingNowLuxury = ({
  dataProducts,
  isFetching,
  getProducts,
  history,
  dataTrending,
  getTrendingProduct
}) => {

  const [trending, setTrending] = useState([])

  useEffect(() => {
    const payload = {
      params: {
        category: "handbags",
        per_page: 20,
        page: 1
      }
    }

    getTrendingProduct(payload, "handbags")
  }, []);

  useEffect(() => {
    setTrending(dataTrending.filter(item => item.price))
  }, [dataTrending])

  if (!trending) return null;

  return (
    <div style={{ width: "90vw", margin: "50px auto 0px auto" }} className="hot-products-section">
      <h6>Trending Now</h6>
      <p className="view-all">
        <Link to={`/luxury/trending-now`} target="_blank">
          View All
        </Link>
      </p>
      <CarouselProduct dataProducts={trending} history={history} isLuxuryTrendingNow />
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataProducts: state.dataProduct.products.data,
  isFetching: state.dataProduct.isFetch,
  dataTrending: state.dataProduct.trending.data
})

const mapDispatchToProps = dispatch => ({
  getProducts: () => dispatch(doFetchProducts()),
  getTrendingProduct: (payload, category) => dispatch(getTrendingProduct(payload, category))
})

export default connect(mapStateToProps, mapDispatchToProps)(TrendingNowLuxury);
